export default __webpack_public_path__ + "static/media/vission.ac07cad9.png";